module.exports = __webpack_public_path__ + "img/电饭煲.f8657bc2.png";